var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbExists)?_c('v-img',{class:['course-name', { isMember: _vm.isMember }],staticStyle:{"background-color":"transparent"},attrs:{"src":_vm.thumbSrc,"contain":"","eager":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }